import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _DEAL_TYPES_DISPLAY_N;

export var DEAL_TYPES = {
  PERSONAL: 'PERSONAL',
  BUSINESS: 'BUSINESS',
  DEALER_TRADE: 'DEALER_TRADE',
  FNI: 'ONLY_FINANCE_AND_INSURANCE',
  WHOLESALE: 'WHOLESALE',
  FLEET: 'FLEET',
  INTERNET: 'INTERNET',
  HOUSE: 'HOUSE',
  EMPLOYEE_PURCHASE: 'EMPLOYEE_PURCHASE',
  INTERNAL_TRANSFER: 'INTERNAL_TRANSFER',
  ONLY_TRADES: 'ONLY_TRADES',
  REFINANCING: 'REFINANCING'
};
export var DEAL_TYPES_DISPLAY_NAMES = (_DEAL_TYPES_DISPLAY_N = {}, _defineProperty(_DEAL_TYPES_DISPLAY_N, DEAL_TYPES.PERSONAL, __('Personal')), _defineProperty(_DEAL_TYPES_DISPLAY_N, DEAL_TYPES.BUSINESS, __('Business')), _defineProperty(_DEAL_TYPES_DISPLAY_N, DEAL_TYPES.DEALER_TRADE, __('Dealer Trade')), _defineProperty(_DEAL_TYPES_DISPLAY_N, DEAL_TYPES.FNI, __('Only Finance and Insurance')), _defineProperty(_DEAL_TYPES_DISPLAY_N, DEAL_TYPES.WHOLESALE, __('Wholesale')), _defineProperty(_DEAL_TYPES_DISPLAY_N, DEAL_TYPES.FLEET, __('Fleet')), _defineProperty(_DEAL_TYPES_DISPLAY_N, DEAL_TYPES.INTERNET, __('Internet')), _defineProperty(_DEAL_TYPES_DISPLAY_N, DEAL_TYPES.HOUSE, __('House')), _defineProperty(_DEAL_TYPES_DISPLAY_N, DEAL_TYPES.EMPLOYEE_PURCHASE, __('Employee Purchase')), _defineProperty(_DEAL_TYPES_DISPLAY_N, DEAL_TYPES.INTERNAL_TRANSFER, __('Internal Transfer')), _defineProperty(_DEAL_TYPES_DISPLAY_N, DEAL_TYPES.ONLY_TRADES, __('Only Trade-in')), _defineProperty(_DEAL_TYPES_DISPLAY_N, DEAL_TYPES.REFINANCING, __('Refinance')), _DEAL_TYPES_DISPLAY_N);